import React from "react";

interface ContactConfirmProps {
    closeConfirmModal: () => any;
}


const ContactConfirm: React.FC<ContactConfirmProps> = ({ closeConfirmModal }) => {

    return (
        <>
            <div
                className="modal custom-modal fade check-availability-modal"
                id="confirm"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content py-0 ">

                        <div className="modal-body mb-0">


                            <div className="row">

                                <div className="col-md-4">

                                </div>
                                <div className="col-md-4 text-center">

                                </div>
                                <div className="col-md-4 d-flex justify-content-end">
                                    <span className="align-center text-black fs-xx-large" onClick={() => {
                                        closeConfirmModal()
                                    }} >
                                        ×
                                    </span>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-md-4">
                                </div>
                                <div className="col-md-4 text-center">
                                    <h4 className="mb-0  fw-bold text-uppercase">Thank You!</h4>
                                </div>
                                <div className="col-md-4 d-flex justify-content-end">
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 py-3 text-center">
                                    <p> We will get back to you on this shortly</p>
                                </div>


                                <div className="col-md-12 py-3 text-center">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            closeConfirmModal()
                                        }}
                                        className="btn btn-primary w-100 py-1" >
                                        {"Continue"}</button>

                                </div>



                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactConfirm;